<template>
  <footer class="mobile-footer hidden-sm-and-up">
    <div class="mobile-footer-brand">
      <img
        class="mobile-footer-logo"
        src="@/assets/img/home/logo.png"
        alt="鸿能"
      >
      <div class="mobile-footer-brand-text">
        <p class="brand-name">山东智能工业装备有限公司</p>
        <p class="brand-en">HONG NENG</p>
      </div>
    </div>

    <div class="mobile-footer-sections">
      <section class="footer-section">
        <h3 class="footer-section-title">产品</h3>
        <div class="footer-link-grid">
          <span @click="handleToRouter('/production/1')">软件与AI</span>
          <span @click="handleToRouter('/production/2')">新能源</span>
          <span @click="handleToRouter('/production/3')">新装备</span>
        </div>
      </section>

      <section class="footer-section">
        <h3 class="footer-section-title">内容中心</h3>
        <div class="footer-link-grid">
          <span @click="handleToRouter('/fournav/1')">行业报告</span>
          <span @click="handleToRouter('/fournav/2')">精选文章</span>
          <span @click="handleToRouter('/fournav/3')">媒体报道</span>
        </div>
      </section>

      <section class="footer-section footer-section--contact">
        <h3 class="footer-section-title">联系我们</h3>
        <ul class="footer-contact-list">
          <li>
            <a href="tel:0531-82899508">
              <i class="el-icon-phone"></i>
              <span>0531-82899508</span>
            </a>
          </li>
          <li>
            <a href="mailto:zngyzb@zngyzb.com">
              <i class="el-icon-message"></i>
              <span>zngyzb@zngyzb.com</span>
            </a>
          </li>
          <li>
            <i class="el-icon-location-outline"></i>
            <span>山东省济南市历城区郭店街道虞山路4567号新页智能智造产业园4号楼东座102户</span>
          </li>
        </ul>
      </section>
    </div>

    <div class="mobile-footer-legal">
      <p class="copyright">
        Copyright ©2025 山东智能工业装备 . All Rights Reserved .
      </p>
      <div class="beian-links">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          鲁ICP备2025153067号-1
        </a>
        <span class="beian-divider">|</span>
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=37011202002399"
          rel="noreferrer noopener"
          target="_blank"
          class="beian-gongan"
        >
          <img src="@/assets/img/备案图标.png" alt="">
          鲁公网安备37011202002399号
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    handleToRouter (url) {
      this.$router.push(url).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-footer {
  margin-top: 32PX;
  padding: 28PX 16PX calc(24PX + env(safe-area-inset-bottom, 0px));
  background: #21282d;
  color: #fff;
}

.mobile-footer-brand {
  display: flex;
  align-items: center;
  gap: 12PX;
  padding-bottom: 24PX;
  border-bottom: 1PX solid rgba(255, 255, 255, 0.08);
}

.mobile-footer-logo {
  width: 48PX;
  height: 48PX;
  flex-shrink: 0;
  object-fit: contain;
}

.mobile-footer-brand-text {
  min-width: 0;
}

.brand-name {
  margin: 0;
  font-size: 15PX;
  font-weight: 600;
  line-height: 1.4;
  color: #fff;
}

.brand-en {
  margin: 4PX 0 0;
  font-size: 12PX;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.45);
}

.mobile-footer-sections {
  padding: 8PX 0 4PX;
}

.footer-section {
  padding: 16PX 0;
  border-bottom: 1PX solid rgba(255, 255, 255, 0.06);

  &:last-child {
    border-bottom: none;
  }
}

.footer-section-title {
  margin: 0 0 12PX;
  font-size: 15PX;
  font-weight: 600;
  color: #fff;
}

.footer-link-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10PX 8PX;

  span {
    font-size: 13PX;
    color: rgba(255, 255, 255, 0.55);
    cursor: pointer;
    line-height: 1.4;
    transition: color 0.2s ease;

    &:active {
      color: #f39c00;
    }
  }
}

.footer-section--contact {
  .footer-link-grid {
    display: none;
  }
}

.footer-contact-list {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: flex-start;
    gap: 8PX;
    font-size: 13PX;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.55);

    & + li {
      margin-top: 12PX;
    }

    i {
      flex-shrink: 0;
      margin-top: 2PX;
      font-size: 15PX;
      color: rgba(255, 255, 255, 0.35);
    }

    a {
      display: flex;
      align-items: flex-start;
      gap: 8PX;
      color: inherit;
      text-decoration: none;

      &:active {
        color: #f39c00;
      }
    }
  }
}

.mobile-footer-legal {
  margin-top: 20PX;
  padding-top: 20PX;
  border-top: 1PX solid rgba(255, 255, 255, 0.08);
  text-align: center;
}

.copyright {
  margin: 0;
  font-size: 11PX;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.35);
}

.beian-links {
  margin-top: 10PX;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6PX 8PX;
  font-size: 11PX;
  line-height: 1.5;

  a {
    color: rgba(255, 255, 255, 0.4);
    text-decoration: none;

    &:active {
      color: rgba(255, 255, 255, 0.65);
    }
  }
}

.beian-divider {
  color: rgba(255, 255, 255, 0.2);
}

.beian-gongan {
  display: inline-flex;
  align-items: center;
  gap: 4PX;

  img {
    width: 13PX;
    height: 13PX;
    flex-shrink: 0;
  }
}
</style>
